<template>
  <div class="user-wrap">
    <UserHead ></UserHead>
  </div>
</template>
<script>
import UserHead from "components/UserHead";
export default {
  name:'User',
  components: {
    UserHead
  },
  data() {
    return {
    }
  },
  computed: {
  },
  activated() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang="less" scoped>
</style>